<i18n>
{
	"en": {
		"title": "Incoterms Code",
		"couldNotFindIncoterm": "Could not find incoterm"
	},
	"no": {
		"title": "Incoterms Kode",
		"couldNotFindIncoterm": "Fant ikke incoterm"
	}
}
</i18n>

<template>
	<t-combobox-button
		:title="$t('title')"
		icon="book"
		displayKey="code"
		:showCount="false"
		showPopoverOnFocus

		:searchValue="searchValue"
		:items="sortedFilteredItems"
		:selected="value"

		:disabled="disabled || hasNoIncoterms"
		buttonDisabled

		@input="onInput"
		@change="onChange"
		@blur="onBlur"
	>
		<template #optionItemContent="slotProps">
			<div class="item">
				<div class="item-main-text">{{ `${slotProps.item.code} - ${slotProps.item.description.no}` }}</div>
			</div>
		</template>
	</t-combobox-button>
</template>

<script>
import { mapState, mapActions } from './store/incoterms.store';
import TComboboxButton from '@/components/evergreen/timpex/inputs/TComboboxButton';

export default {
	name: 'IncotermInput',
	components: { TComboboxButton },
	props: {
		value: Object,
		disabled: {
			type: Boolean,
			default: false
		},
	},
	data() {
		return {
			searchValue: '',
		};
	},
	computed: {
		...mapState(['incoterms']),
		hasNoIncoterms() {
			return !this.incoterms || this.incoterms.length === 0;
		},

		filteredItems() {

			if (this.searchValue.length) {

				return this.incoterms.filter(
					incoterm =>
						incoterm.code.toLowerCase().includes(this.searchValue.toLowerCase())
						|| incoterm.description.no.toLowerCase().includes(this.searchValue.toLowerCase())
				);

			} else {
				return this.incoterms;
			}
		},

		sortedFilteredItems() {

			let sortedFilteredItems = [...this.filteredItems];

			sortedFilteredItems.sort( (a, b) => {
				if (a.code < b.code) return -1;
				if (a.code > b.code) return 1;
				return 0;
			} );

			return sortedFilteredItems;
		}
	},
	watch: {
		value: {
			immediate: true,

			handler(incoterm) {
				if (incoterm && incoterm.code)
					this.searchValue = incoterm.code;
			}
		}
	},
	async created() {
		await this.getIncoterms();
	},
	methods: {
		...mapActions(['getIncoterms']),

		onInput(searchValue) {
			this.searchValue = searchValue;
		},
		onChange(event) {

			if (event && event.code) {
				this.searchValue = event.code;
				this.$emit('change', event);
			} else
				this.$emit('change', undefined);
		},
		onBlur() {

			if (this.searchValue === '') {

				this.$emit('change', undefined);
				return;
			}

			let incoterm = this.incoterms.find(
				incoterm => this.searchValue.toLowerCase() === incoterm.code.toLowerCase()
			);

			if (incoterm && incoterm !== this.value) {
				this.$emit('change', incoterm);

			} else
				this.searchValue = this.getSearchValueFromValue(this.value);
		},
		getSearchValueFromValue(value) {
			if (value && value.code && value.code.length)

				return value.description && value.description.no && value.description.no.length
					? `${value.code} - ${value.description.no}`
					: value.code;

			else
				return '';
		}
	}
};
</script>
